"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERSONAL_INFORMATION_FIELDS = void 0;
var entities_1 = require("@common/entities");
exports.PERSONAL_INFORMATION_FIELDS = [
    __assign(__assign({}, entities_1.PersonalInformationFields.firstName), { customType: entities_1.FieldType.Text, required: true, type: entities_1.FieldType.Text, enabled: true, sequence: 1 }),
    __assign(__assign({}, entities_1.PersonalInformationFields.lastName), { customType: entities_1.FieldType.Text, required: true, type: entities_1.FieldType.Text, enabled: true, sequence: 2 }),
    __assign(__assign({}, entities_1.PersonalInformationFields.email), { customType: entities_1.FieldType.Email, required: true, type: entities_1.FieldType.Email, enabled: true, sequence: 3 }),
    __assign(__assign({}, entities_1.PersonalInformationFields.dateOfBirth), { customType: entities_1.FieldType.Date, placeholder: 'MM/DD/YYYY', required: true, type: entities_1.FieldType.Date, enabled: true, sequence: 4 }),
    __assign(__assign({}, entities_1.PersonalInformationFields.phoneNumber), { customType: entities_1.FieldType.PhoneNumber, type: entities_1.FieldType.PhoneNumber, formatting: '1', required: true, enabled: true, sequence: 5 }),
];
